import { z } from "zod";

export enum EOrganizationType {
  ORGANIZATION = "Organization",
}

export enum ESiteType {
  HOSPITALITY = "HOSPITALITY",
  SOCIAL_HOUSING = "SOCIAL_HOUSING",
  STUDENT_HOUSING = "STUDENT_HOUSING",
}

export enum ESiteOrigin {
  PROSPECTING_CAMPAIGN = "PROSPECTING_CAMPAIGN",
  REGIONAL_PARTNERSHIP = "REGIONAL_PARTNERSHIP",
}

export interface IOrganizationSite {
  id: number;
  name: string;
  organizationId: number;
  numDevices: number;
}

interface IOrganization {
  id: number;
  name: string;
  parentId: number;
  address: string | null;
  postalCode: string | null;
  city: string | null;
  numUsers: number;
  creatorId: number;
  creationDateTime: string;
  sites: IOrganizationSite[];
  children: IOrganization[];
}

const organizationSiteSchema = z.object({
  id: z.number(),
  name: z.string(),
  organizationId: z.number(),
  numDevices: z.number(),
});

export const organizationSchema: z.ZodType<IOrganization> = z.object({
  id: z.number(),
  name: z.string(),
  parentId: z.number(),
  address: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
  numUsers: z.number(),
  creatorId: z.number(),
  creationDateTime: z.string(),
  sites: z.array(organizationSiteSchema),
  children: z.lazy(() => z.array(organizationSchema)),
});

export type TOrganizationSite = z.infer<typeof organizationSiteSchema>;
export type TOrganization = z.infer<typeof organizationSchema>;
